$(".faq-area li:first-child").addClass("active");
$(".faq-area li:first-child button").attr("aria-expanded","true");
$(".faq-area li:first-child p").show();
$(".faq-area ul li button").click(function () {
  $(this).parent("li").toggleClass("active");
  $(this).next("p").slideToggle();
});


$(".template-product .product-image").slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  prevArrow:"<button type='button' class='slick-prev pull-left'><i class='icon-angle-up'></i></button>",
  nextArrow:"<button type='button' class='slick-next pull-right'><i class='icon-angle-down'></i></button>",
  responsive: [
    {
      breakpoint: 768,
      settings: "unslick"
      // settings: {
      //   infinite: false,
      //   slidesToShow: 1,
      //   slidesToScroll: 1,
      //   centerMode: true,
      //   centerPadding: '30px',
      //   arrows: false,
      // },
    },
  ],
});


// $(".hello-product .product-image").slick({
//   infinite: false,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: true,
//   prevArrow:"<button type='button' aria-label='previous button' class='slick-prev pull-left'><i class='icon-angle-up'></i></button>",
//   nextArrow:"<button type='button' class='slick-next pull-right' aria-label='next button'><i class='icon-angle-down'></i></button>",
//   responsive: [
//     {
//       breakpoint: 767,
//       settings: {
//         infinite: false,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         centerMode: true,
//         centerPadding: '20%',
//         arrows: false,
//         dots: true,
//       },
//     },
//   ],
// });

 $('.slider-nav')
 	.on('init', function(event, slick) {
 		$('.slider-nav .slick-slide.slick-current').addClass('is-active');
 	}).slick({
  infinite: false,
  slidesToShow: 6,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  focusOnSelect: true,
  prevArrow:"<button type='button' aria-label='previous button' class='slick-prev pull-left'><i class='icon-angle-up'></i></button>",
  nextArrow:"<button type='button' aria-label='next button' class='slick-next pull-right'><i class='icon-angle-down'></i></button>",
  responsive: [
    {
      breakpoint: 992,
      settings: {
        vertical: false,
        slidesToShow: 6,
        dots: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        vertical: false,
        slidesToShow: 6,
        dots: false,
      },
    },
    {
      breakpoint: 767,
      settings: {
        vertical: false,
        slidesToShow: 6,
        dots: false,
      },
    },
    {
      breakpoint: 400,
      settings: {
        vertical: false,
        slidesToShow: 6,
        dots: false,
      },
    },
  ],
});
 $('.product-image').on('afterChange', function(event, slick, currentSlide) {
 	$('.slider-nav').slick('slickGoTo', currentSlide);
 	var currrentNavSlideElem = '.slider-nav .slick-slide[data-slick-index="' + currentSlide + '"]';
 	$('.slider-nav .slick-slide.is-active').removeClass('is-active');
 	$(currrentNavSlideElem).addClass('is-active');
 });

 $('.slider-nav').on('click', '.slick-slide', function(event) {
 	event.preventDefault();
 	var goToSingleSlide = $(this).data('slick-index');

 	$('.product-image').slick('slickGoTo', goToSingleSlide);
 });
$(
  ".product-view .product-options-bottom .add-to-cart-box .button-wrapper .btn-cart span"
).click(function () {
  $(this).text("Added!");
  setTimeout(function () {
    $(
      ".product-view .product-options-bottom .add-to-cart-box .button-wrapper .btn-cart span"
    ).text("Add to Cart");
  }, 4500);
});
$(".sticky-product.has-sticky-header select").click(function (e) {
  var option = $("option:selected", this).attr("data-price");
  $(".sticky-price").text(option);
});
 $(".product-grid-options-size").change(function () {
    var selectedOption = $(this).find("option:selected");
    var colPrice = selectedOption.attr("data-colprice");
    var discountPrice = selectedOption.attr("data-discountprice");
    
    $(this)
      .parents(".product-grid-options-size")
      .find(".size-swatches a")
      .removeClass("active");
    selectedOption.addClass("active");
    
    var href = selectedOption.attr("value");
    var variantForm = $(this)
      .parents(".product-grid-options-size")
      .next(".add-links-wrap")
      .find("form");
    variantForm.find("select option").val(href);
    
    $(this)
      .parents(".product-content")
      .find(".price-wrapper > .amount > .money")
      .text(colPrice);
    $(this)
      .parents(".product-content")
      .find(".price-wrapper .discount-price .money")
      .text(discountPrice);
  });

var imageGallery1 = $(".product-image-gallery");
imageGallery1.removeClass("loading");



$(".porto-block-html-top .owl-carousel").owlCarousel({
  loop: true,
  auto: false,
  margin: 0,
  nav: false,
  dots: false,
  autoplay: true,
  autoplayTimeout: 5000,
  autoplayHoverPause: false,
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 1,
    },
    1000: {
      items: 1,
    },
  },
});
$(".our-partners .owl-carousel").owlCarousel({
  loop: false,
  auto: false,
  margin: 0,
  nav: false,
  dots: false,
  autoplay: true,
  autoplayTimeout: 3000,
  autoplayHoverPause: false,
  responsive: {
    0: {
      items: 2,
      loop: true,
    },
    600: {
      items: 3,
      loop: true,
    },
    1000: {
      items: 5,
    },
  },
});

$(
  ".header-left .top-navigation li.level0 .ulmenu-block.ulmenu-block-center ul li:first-child a"
).addClass("active");
$(
  ".header-left .top-navigation li.level0 .ulmenu-block.ulmenu-block-center ul li:first-child a"
).mouseover(function (e) {
  $(
    ".header-left .top-navigation li.level0 .ulmenu-block.ulmenu-block-center ul li a"
  ).removeClass("active");
  $(this).addClass("active");
  $(".mega-menus1").fadeIn();
  $(".mega-menus2").hide();
  $(".mega-menus3").hide();
  $(".mega-menus4").hide();
});
$(
  ".header-left .top-navigation li.level0 .ulmenu-block.ulmenu-block-center ul li:nth-child(2) a"
).mouseover(function (e) {
  $(
    ".header-left .top-navigation li.level0 .ulmenu-block.ulmenu-block-center ul li a"
  ).removeClass("active");
  $(this).addClass("active");
  $(".mega-menus1").hide();
  $(".mega-menus2").fadeIn();
  $(".mega-menus3").hide();
  $(".mega-menus4").hide();
});
$(
  ".header-left .top-navigation li.level0 .ulmenu-block.ulmenu-block-center ul li:nth-child(3) a"
).mouseover(function (e) {
  $(
    ".header-left .top-navigation li.level0 .ulmenu-block.ulmenu-block-center ul li a"
  ).removeClass("active");
  $(this).addClass("active");
  $(".mega-menus1").hide();
  $(".mega-menus2").hide();
  $(".mega-menus3").fadeIn();
  $(".mega-menus4").hide();
});
$(
  ".header-left .top-navigation li.level0 .ulmenu-block.ulmenu-block-center ul li:nth-child(4) a"
).mouseover(function (e) {
  $(
    ".header-left .top-navigation li.level0 .ulmenu-block.ulmenu-block-center ul li a"
  ).removeClass("active");
  $(this).addClass("active");
  $(".mega-menus1").hide();
  $(".mega-menus2").hide();
  $(".mega-menus3").hide();
  $(".mega-menus4").fadeIn();
});
if ($(window).width() < 991) {
  $(".our-sponsers .col-12 > div").addClass("owl-carousel");
  $(".our-sponsers .owl-carousel").owlCarousel({
    loop: false,
    auto: false,
    margin: 0,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 1000,
    autoplayHoverPause: false,
    responsive: {
      0: {
        items: 2,
        loop: true,
      },
      600: {
        items: 3,
        loop: true,
      },
      1000: {
        items: 6,
      },
    },
  });
}

var imageGallery = $(".home-slider24 .product-image .product-image-gallery");
imageGallery.removeClass("loading");
setTimeout(function(){
$(".home-slider24 #more-slides a").on("mouseenter", function () {
  var targetImage = $(this).closest(".product-img-list").find(".gallery-image");
  if (targetImage.attr("src") != $(this).data("image")) {
    $(".zoomContainer").remove();
    targetImage.removeData("elevateZoom");
    targetImage.attr("src", $(this).data("image"));
    targetImage.data("zoom-image", $(this).data("zoom-image"));
  }
});
},1000);


var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.main-section-header').outerHeight();

$(window).scroll(function(event){
    didScroll = true;
});

setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    var st = $(this).scrollTop();
    
    // Make scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
        return;
    
    // If scrolled down and past the navbar, add class .nav-up.
    if (st > lastScrollTop && st > navbarHeight){
        // Scroll Down
        $('.main-section-header').removeClass('nav-down').addClass('nav-up');
      $('.header-notice').removeClass('sticky-notice');
  
    } else {
        // Scroll Up
        if(st + $(window).height() < $(document).height()) {
            $('.main-section-header').removeClass('nav-up').addClass('nav-down');
          $('.header-notice').addClass('sticky-notice');
       
        }
    }
  
    lastScrollTop = st;
}

setTimeout(function() {
$('#mobile-menu > li:nth-child(1) > span').addClass('expand').removeClass('.collapse');
},1000)



$(document).ready(function() {
  // Get the value of the first variant
  var defaultVariant = $('.variant-items input[type="radio"]').first().val();

  // Set the default variant value in the span
  $('#selected-variant').text(defaultVariant);

  // Event handler for variant change
  $('.variant-items input[type="radio"]').on('change', function() {
    var selectedVariant = $(this).val();
    $('#selected-variant').text(selectedVariant);
  });
});



$(document).ready(function() {
if(window.location.href == 'https://www.mylklabs.com/collections/subscribe-save'){
var orig_p = "$100.00";
var pri = "$80.75"; 
$('.custom_orig_pri').text(orig_p);
$('.custom_disc_pri').text(pri);
$(".p1-mo-oatmeal-variety-pack .size-swatches").on("click", function() {
var index = $(this).index();
var orig_price;
var price; 
if (index === 0) {
orig_price = "$100.00"
price = "$80.75";
$('.custom_orig_pri').text(orig_price);
$('.custom_disc_pri').text(price);
$('.sub_price > span').text(price);
$('.amount_sub > span.money').text(orig_price);
} else if (index === 1) {
orig_price = "$200.00"
price = "$151.05";
$('.custom_orig_pri').text(orig_price);
$('.custom_disc_pri').text(price);
$('.amount_sub > span.money').text(orig_price);
$('.sub_price > span').text(price);

} else if (index === 2) {
orig_price = "$300.00"
price = "$213.75";
$('.custom_orig_pri').text(orig_price);
$('.custom_disc_pri').text(price);
$('.amount_sub > span.money').text(orig_price);
$('.sub_price > span').text(price);
}
});
  $('#product-selectors6').on('change', function() {
let val = $(this).val();
var orig_price_;
var price_; 
if(val == '39771214381150'){
orig_price_ = "$100.00"
price_ = "$80.75"; 
$('.sub_price > span').text(price_);
$('.amount_sub > span.money').text(orig_price_)
}else if(val == '39988334264414'){
orig_price_ = "$200.00"
price_ = "$151.05";
  $('.sub_price > span').text(price_);
$('.amount_sub > span.money').text(orig_price_)
}else if(val == '39988336885854'){
orig_price_ = "$300.00"
price_ = "$213.75";
  $('.sub_price > span').text(price_);
$('.amount_sub > span.money').text(orig_price_)
}
});
}else{
  var orig_p_2 = "$100.00";
var pri_2 = "$85.00"; 
$('.custom_orig_pri').text(orig_p_2);
$('.custom_disc_pri').text(pri_2);
  $(".p1-mo-oatmeal-variety-pack .size-swatches").on("click", function() {
var index = $(this).index();
var orig_price___;
var price___; 
if (index === 0) {
orig_price___ = "$100.00"
price___ = "$85.00";
$('.custom_orig_pri').text(orig_price___);
$('.custom_disc_pri').text(price___);
} else if (index === 1) {
orig_price___ = "$200.00"
price___ = "$159.00";
$('.custom_orig_pri').text(orig_price___);
$('.custom_disc_pri').text(price___);
} else if (index === 2) {
orig_price___ = "$300.00"
price___ = "$225.00";
$('.custom_orig_pri').text(orig_price___);
$('.custom_disc_pri').text(price___);
}
});
}
});

//   $('.gallery-image').click(function(){
//     var img = $(this).parents('.product-image').html();
//     $('.PDP-images').children().remove();
//     $('.PDP-images').append(img);
//     $('.PDP-image-wrapper').addClass('visibl');
//     $('html').addClass('ovrflow');
// });
//     $('.pop-close').click(function(){
//     $('.PDP-image-wrapper').removeClass('visibl');
//     $('html').removeClass('ovrflow');
// });

$( document ).ready(function() {
  $('.level1').addClass('active');
});

$(document).ready(function(){
$('#readMore').click(function(){
$('.mobile-desc').hide();
$('.short-description').show();
});
});


function updateCartCount() {
  // Fetch the cart data from the Shopify API
  fetch('/cart.js')
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      // Update the cart quantity on the page
      document.getElementById('CartCount').innerText = data.item_count;
    })
    .catch(function(error) {
      console.error('Error fetching cart data:', error);
    });
}

function addToCartWithAjax(variantId, quantity) {
  // Create the request data
  var formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', quantity);

  // Fetch API to make the AJAX request
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
    .then(function() {
      updateCartCount();
    })
    .catch(function(error) {
      console.error('Error adding item to cart:', error);
    });
}

// Form 1 - Subscribe-Save Collection
document.getElementById('add-to-cart-form').addEventListener('submit', function(event) {
  event.preventDefault();
  // Get the product variant ID and quantity from the form
  var variantId = this.elements['id'].value;
  var quantity = 1; // You can modify this to handle different quantities if needed
  addToCartWithAjax(variantId, quantity);
  return false; 
});

// Form 2 - For other products
document.getElementById('product-main-form').addEventListener('submit', function(event) {
    event.preventDefault(); 
    var variantId = this.elements['id'].value;
    var quantity = 1; 
    addToCartWithAjax(variantId, quantity);
    return false; 
  });